import React from "react";
import { Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { HighlightOff } from "@mui/icons-material";

import "./ResetPasswordExpiredView.css";
import logoImage from "../../../assets/CRMAssets/psconnect_login_logo@2x.png";
import { PrimaryButton } from "../../../components/Buttons/PrimaryButton";

function ResetPasswordExpiredView() {
  return (
    <div className="resetExpiredPage">
      <div className="resetExpiredOverlay"></div>

      <div className="resetExpiredContainer">
        <div className="resetExpiredCard">
          <div className="resetExpiredLogoWrapper">
            <img
              src={logoImage}
              alt="PS Connect"
              className="resetExpiredLogo"
            />
          </div>

          <div className="resetExpiredIconWrapper">
            <div className="resetExpiredErrorCircle">
              <HighlightOff
                style={{
                  color: "#ff6464",
                  fontSize: 48,
                }}
              />
            </div>
          </div>

          <Typography className="resetExpiredTitle">
            Link Expired or Invalid
          </Typography>

          <Typography className="resetExpiredDescription">
            The password reset link has expired or is no longer valid.
            <br />
            Reset links are only active for 1 hour.
          </Typography>

          <div className="resetExpiredButtonWrapper">
            <PrimaryButton
              className="resetExpiredButton"
              onClick={() => (window.location.href = "/forgot-password")}
            >
              REQUEST NEW LINK →
            </PrimaryButton>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ResetPasswordExpiredView;